<template>
    <v-container fluid style="margin: 60px 10%">
      <vueHeadful
      :title="this.$i18n.t('Menu.AdministracionGeneral') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row align="center">
            <v-col cols="12" xs="12" sm="6" md="3" align="center">
                <p class="display-1 vietnam">{{$t('Administracion.Letra')}}</p>
                <Chrome v-if="general.duo" v-model="general.duo.colorTexto" />
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="3" align="center">
                <p class="display-1 vietnam">{{$t('Administracion.Fondo')}}</p>
                <Chrome v-if="general.duo" v-model="general.duo.colorFondo"/>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="3" align="center">
                <div v-if="general.duo" :style="'background:'+general.duo.colorFondo.hex8">
                <v-hover v-slot:default="{ hover }">
                    <v-img :id="hover ? 'duo' : ''" :src="general.duo.imagenArtistas" max-height="700" aspect-ratio="1">
                    <v-container fill-height>
                        <v-row>
                        <v-col cols="12" align="center" justify="center">
                        <h2 class="font-weight-black" :style="textoInicio+'color:'+ general.duo.colorTexto.hex8">{{ $t('Menu.Artistas').toUpperCase() }}</h2>
                        </v-col>
                    </v-row>
                    </v-container>
                    </v-img>
                </v-hover>
                </div>
                <v-file-input class="mt-5" solo v-model="general.imagenArtistas" accept="image/*"/>
                <v-btn outlined style="border: 2px solid" x-large class="mt-2" @click="actualizarInicio('artistas')">{{$t('Administracion.NuevaImagen')}}</v-btn>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="3" align="center">
                <div v-if="general.duo" :style="'background:'+general.duo.colorFondo.hex8">
                <v-hover v-slot:default="{ hover }">
                    <v-img :id="hover ? 'duo' : ''" :src="general.duo.imagenDisenadores" max-height="700" aspect-ratio="1">
                    <v-container fill-height>
                        <v-row>
                        <v-col cols="12" align="center" justify="center">
                        <h2 class="font-weight-black" :style="textoInicio+'color:'+ general.duo.colorTexto.hex8">{{ $t('Menu.Disenadores').toUpperCase() }}</h2>
                        </v-col>
                    </v-row>
                    </v-container>
                    </v-img>
                </v-hover>
                </div>
                <v-file-input class="mt-5" solo v-model="general.imagenDisenadores" accept="image/*"/>
                <v-btn outlined style="border: 2px solid" x-large class="mt-2" @click="actualizarInicio('disenadores')">{{$t('Administracion.NuevaImagen')}}</v-btn>
            </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="center">
            <v-checkbox v-model="seguridad.carrito" label="Ventas Activadas" color="black"/>
            <h2 v-if="!seguridad.carrito">Al desactivar esta opción, nadie podrá comprar en TrArtist</h2>
          </v-col>
        </v-row>
        <v-row style="padding: 60px 0;">
          <v-col cols="12" xs="12" md="6" align="center">
            <v-file-input v-model="contratoEs" label="Contrato en Español" solo />
            <v-btn color="black white--text" @click="descargar('contratoEs')" large>Contrato en Español</v-btn>
          </v-col>
          <v-col cols="12" xs="12" md="6" align="center">
            <v-file-input v-model="contratoEn" label="Contrato en Inglés" solo />
            <v-btn color="black white--text" @click="descargar('contratoEn')" large>Contrato en Inglés</v-btn>
          </v-col>
          <v-col cols="12" xs="12" md="6" align="center">
            <v-file-input v-model="certificadoEs" label="Certificado de Autenticidad en Español" solo />
            <v-btn color="black white--text" @click="descargar('certificadoEs')" large>Certificado de Autenticidad en Español</v-btn>
          </v-col>
          <v-col cols="12" xs="12" md="6" align="center">
            <v-file-input v-model="certificadoEn" label="Certificado de Autenticidad en Inglés" solo />
            <v-btn color="black white--text" @click="descargar('certificadoEn')" large>Certificado de Autenticidad en Inglés</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="center">
              <v-btn class="mt-5" color="primary" @click="actualizarInicio('todo')" :loading="getCargandoAccion" x-large style="min-width:20%!important">{{ $t('Formularios.Actualizar') }}</v-btn>
          </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { Chrome } from 'vue-color'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'AdministracionGeneral',
  data () {
    return {
      certificadoEs: null,
      certificadoEn: null,
      contratoEs: null,
      contratoEn: null,
      general: {
        duo: null,
        imagenArtistas: null,
        imagenDisenadores: null
      },
      seguridad: {
        carrito: true
      }
    }
  },
  components: {
    Chrome
  },
  mounted () {
    firebase.firestore().collection('utilidades').doc('inicio').get().then(info => {
      this.general.duo = info.data()
    })
    firebase.firestore().collection('utilidades').doc('seguridad').get().then(info => {
      this.seguridad = info.data()
    })
  },
  computed: {
    ...mapGetters(['getCargandoAccion']),
    textoInicio () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:1rem;'
        case 'sm': return 'font-size:1rem;'
        case 'md': return 'font-size:1.5rem;'
        case 'lg': return 'font-size:2rem;'
        case 'xl': return 'font-size:3rem;'
        default: return 'font-size:3rem;'
      }
    }
  },
  methods: {
    ...mapMutations(['setCargandoAccion', 'setAlerta', 'setTextoAlerta']),
    descargar (tipo) {
      firebase.firestore().collection('utilidades').doc('contrato').get().then(info => {
        if (tipo === 'contratoEs') {
          window.open(info.data().contratoEs, '_blank')
        } else if (tipo === 'contratoEn') {
          window.open(info.data().contratoEn, '_blank')
        }
        if (tipo === 'certificadoEs') {
          window.open(info.data().certificadoEs, '_blank')
        }
        if (tipo === 'certificadoEn') {
          window.open(info.data().certificadoEn, '_blank')
        }
      })
    },
    async imagenInicio (imagen) {
      var upload = await firebase.storage().ref('utilidades').child(imagen.name).put(imagen)
      var url = await upload.ref.getDownloadURL()
      return url
    },
    async actualizarInicio (tipo) {
      this.setCargandoAccion(true)
      if (tipo === 'todo') {
        if (this.certificadoEs) {
          var archivoCertEs = await firebase.storage().ref().child('documentos/' + this.certificadoEs.name).put(this.certificadoEs)
          var urlCertificadoEs = await archivoCertEs.ref.getDownloadURL()
          firebase.firestore().collection('utilidades').doc('contrato').update({
            certificadoEs: urlCertificadoEs
          })
          this.certificadoEs = null
        }
        if (this.certificadoEn) {
          var archivoCertEn = await firebase.storage().ref().child('documentos/' + this.certificadoEn.name).put(this.certificadoEn)
          var urlCertificadoEn = await archivoCertEn.ref.getDownloadURL()
          firebase.firestore().collection('utilidades').doc('contrato').update({
            certificadoEn: urlCertificadoEn
          })
          this.certificadoEn = null
        }
        if (this.contratoEs) {
          var archivoContratoEs = await firebase.storage().ref().child('documentos/' + this.contratoEs.name).put(this.contratoEs)
          var urlContratoEs = await archivoContratoEs.ref.getDownloadURL()
          firebase.firestore().collection('utilidades').doc('contrato').update({
            contratoEs: urlContratoEs
          })
          this.contratoEs = null
        }
        if (this.contratoEn) {
          var archivoContratoEn = await firebase.storage().ref().child('documentos/' + this.contratoEn.name).put(this.contratoEn)
          var urlContratoEn = await archivoContratoEn.ref.getDownloadURL()
          firebase.firestore().collection('utilidades').doc('contrato').update({
            contratoEn: urlContratoEn
          })
          this.contratoEn = null
        }
        firebase.firestore().collection('utilidades').doc('seguridad').update(this.seguridad)
        firebase.firestore().collection('utilidades').doc('inicio').update(this.general.duo).then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionActualizada')
          this.setCargandoAccion(false)
        })
      }
      if (tipo === 'artistas') {
        this.imagenInicio(this.general.imagenArtistas).then(url => {
          this.general.duo.imagenArtistas = url
          this.setAlerta()
          this.setTextoAlerta('Alerta.ImagenCargada')
          this.setCargandoAccion(false)
        })
      }
      if (tipo === 'disenadores') {
        this.imagenInicio(this.general.imagenDisenadores).then(url => {
          this.general.duo.imagenDisenadores = url
          this.setAlerta()
          this.setTextoAlerta('Alerta.ImagenCargada')
          this.setCargandoAccion(false)
        })
      }
    }
  }
}
</script>

<style>
#duo .v-image__image{
  opacity: 0.6!important;
}
</style>
